import { render, staticRenderFns } from "./MallDecorateV2.vue?vue&type=template&id=57ad7480&scoped=true"
import script from "./MallDecorateV2.vue?vue&type=script&lang=js"
export * from "./MallDecorateV2.vue?vue&type=script&lang=js"
import style0 from "./MallDecorateV2.vue?vue&type=style&index=0&id=57ad7480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad7480",
  null
  
)

export default component.exports